import {classNames, React, styled} from '@api'
import {Button, IButtonProps} from '@blueprintjs/core'
import {Typography} from '@material-ui/core'
import * as css from './LabeledButton.css'

export const LabeledButton: React.FunctionComponent<{ label?: string, showEllipsis?: boolean } & React.ButtonHTMLAttributes<HTMLButtonElement> & IButtonProps> = ({label, className, text, showEllipsis, children, ...p}) => {
  return (
    <div className={css.container}>
      {label && <Typography className={css.label} variant='h5'>{label}</Typography>}
      <div className={css.rest}>
        {children || <Button {...p}
                minimal
                className={classNames(className, css.root, !!label && css.hasLabel, showEllipsis && css.showEllipsis)}
                text={text}
        />}
      </div>
    </div>)
}


// WEBPACK FOOTER //
// ./src/shared/components/ui/components/LabeledButton.tsx